import React, { useState } from 'react'
import './style.css'
import QuickSearchBanner from '../quick-search-banner/QuickSearchBanner'
import { useSelector } from 'react-redux'

const HomeBanner = () => {

    const [quickSearchShow, setQuickSearchShow] = useState(false)
    const user = useSelector(state => state?.AuthSlice?.user)
    // console.log(user, "auth here");
    const userRole = user?.role?.name;

    const handleQuickSearch = () => {
        setQuickSearchShow((prevState) => !prevState);
    }

    return (
        <>
            <div className="home-main-banner">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="home-banner-text">
                                <h1>Welcome to I-Sit</h1>
                                <p className='common-text'>Your Trusted Partner in Seamless solutions</p>
                            </div>

                            <div className="banner-icon-images">
                                <div className="banner-image-icon red-shadow" onClick={handleQuickSearch}>
                                    <img src="/images/home-bn-1.png" alt="" />
                                    <h3>Verified Professionals</h3>
                                </div>

                                <div className="banner-image-icon blue-shadow">
                                    <img src="/images/home-bn-2.png" alt="" />
                                    <h3>Free Call</h3>
                                </div>

                                <div className="banner-image-icon green-shadow">
                                    <img src="/images/home-bn-3.png" alt="" />
                                    <h3>Licensed Services</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {quickSearchShow && userRole === "user" ? <QuickSearchBanner /> : ""}
            </div>
        </>
    )
}

export default HomeBanner